export default ({ icon, label, ...restProps }) => {
  return (
    <div
      {...restProps}
      className="rip-mm-conf-image-btn"
    >
      <div className="ricon" style={{ width: 60, height: 36, display: "inline-block" }}>
        {icon}
      </div>
      <div className="rlabel">{label}</div>
    </div>
  );
};
